import axios from "src/lib/axios";

export const getOrderListByAdmin = ({
  keyword = null,
  page = null,
  page_size = null,
  status = "all",
}) => {
  return axios.get(`/orders/admin-list`, {
    params: {
      keyword: keyword,
      page: page,
      page_size: page_size,
      status: status,
      order_case: "desc",
    },
  });
};

export const getOrderDetail = (id) => axios.get(`/orders/admin/${id}`);

export const getOrderListOfUser = (user_id) =>
  axios.get(`/orders/admin/user-order-list/${user_id}`);

export const getNotiNewOrder = () => axios.get(`/orders/new-order-noti`);

export const updateStatusOrder = (id, info) => {
  return axios.patch(`/orders/admin-update/${id}`, info);
};
// export const updateSlipOrder = (info) => {
//   return axios.patch(`/orders/admin/slip`, info);
// };

export const refundFullOrder = (id, info) => {
  return axios.patch(`/orders/admin/refund-full/${id}`, info);
};

export const createOrderRefund = (isManage, refund, order_id) => {
  return axios.post(`/orders?manage=${isManage}&refund=${refund}`, order_id);
};

export const getDelivery = () => axios.get(`delivery-types/find-all`);

export const updateSellerSelfDelivery = (info) => {
  return axios.patch(`/lalamove/self-delivery`, info, {
    headers: {
      "Content-Type": "multipart/form-data", // do not forget this
    },
  });
};

export const updateAddressOrder = ({ poId, order }) => {
  return axios.patch(`/purchase-order/update/address/${poId}`, order)
}
